import React from 'react';
import { Admin, Resource, Delete } from 'admin-on-rest';

import { adminRestClient } from './restClient';
import authClient from './authClient';
import { GetServers, CreateServer, EditServer } from './servers';
import { GetPreferences, EditPreference, CreatePreference } from './preferences';
import { GetProxyServers, CreateProxyServer, EditProxyServer } from './proxyserver';

const App = () => (
    <Admin authClient={authClient} restClient={adminRestClient} DeleteButton>
        <Resource name="servers" list={GetServers} create={CreateServer} edit={EditServer} remove={Delete} />
        <Resource name="preferences" list={GetPreferences} create={CreatePreference} edit={EditPreference} />
        <Resource name="proxyservers" list={GetProxyServers} create={CreateProxyServer} edit={EditProxyServer} remove={Delete} />
    </Admin>
);

export default App;


// WEBPACK FOOTER //
// ./src/App.js